var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('MaintenanceGrid',{directives:[{name:"show",rawName:"v-show",value:(_vm.maintenanceActive),expression:"maintenanceActive"}],attrs:{"maintenanceGridItems":_vm.reportTiles}}),_c('router-view',{ref:"rv"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }